// import ApiService from "@/core/services/api.service";
// import JwtService from "@/core/services/jwt.service";
import axios from "axios";
// import cookies from "js-cookie";

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: {},
    },

    getters: {
        isAuthenticated(state) {
            return state.authenticated;
        },

        currentUser(state) {
            return state.user;
        },

        isPremium(state) {
            return state.user.isPremium;
        },

        isEnterprise(state) {
            return state.user.enterprise;
        },

        isAdmin(state) {
            return state.user.id == 3;
        },
    },

    mutations: {
        SET_AUTHENTICATED(state, value) {
            state.authenticated = value;
        },

        SET_USER(state, value) {
            state.user = value;
        },
    },

    actions: {
        async signOut({ dispatch }) {
            await axios.post("auth/logout").catch(() => {});
            return dispatch("me");
        },

        me({ commit }) {
            return axios
                .get("auth/me")
                .then((response) => {
                    commit("SET_AUTHENTICATED", true);
                    commit("SET_USER", response.data);
                })
                .catch(() => {
                    commit("SET_AUTHENTICATED", false);
                    commit("SET_USER", {});
                });
        },
    },
};
